import { circleGraphic, CircleGraphicProps } from './circle-graphic';

export const exposedPopulationGraphic = (
  props: Pick<CircleGraphicProps, 'position' | 'width'>
) =>
  circleGraphic({
    title: 'Full Exposed Population',
    group: 'Exposed users to InMarket universe',
    multiplierDescription: 'Campaign Match Rate Multiplier Calculated (x)',
    position: props.position,
    width: props.width,
    baseColor: 'FF9D1D',
    highlightColor: 'F4B081',
  });
